import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Card from "../Card";

const CommonStep = ({
  step,
  title,
  children,
  footer,
  classes,
  rounded,
  header,
}) => {
  return (
    <Card
      className={classNames("mydpd-card-step", classes.container)}
      rounded={rounded}
    >
      <Card.Header className={classes.header}>
        <Col className="w-100 pl-0">
          <Card.StepTitle
            className={classes.title}
            step={step}
            title={title}
            textClassName={classes.text}
          />
        </Col>
        <Col className="col-auto">
          <Row className="align-items-center">{header}</Row>
        </Col>
      </Card.Header>
      {children}
      {footer && (
        <Card.Footer
          className={classNames("mydpd-card-step-footer", classes.footer)}
        >
          <Container fluid>
            <Row>
              <Col
                className={classNames(
                  "col-12 text-right",
                  classes.footerContent
                )}
              >
                {footer}
              </Col>
            </Row>
          </Container>
        </Card.Footer>
      )}
    </Card>
  );
};

CommonStep.defaultProps = {
  classes: {},
  complete: false,
  isLoading: false,
  rounded: true,
  name: "",
};

CommonStep.propTypes = {
  step: PropTypes.number,
  title: PropTypes.string,
  children: PropTypes.node,
  classes: PropTypes.object,
  footer: PropTypes.elementType,
  rounded: PropTypes.bool,
  header: PropTypes.node,
};

export default CommonStep;
